<h2 mat-dialog-title class="bgDialogHeader text-center">Asset Details
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card>
    <nb-card-body *ngIf="filterData">
      <ng2-smart-table [settings]="settings" [source]="data.dataKey" (userRowSelect)="onRowSelect($event)">
      </ng2-smart-table>
    </nb-card-body>

    <nb-card-body class="noScroll" *ngIf="updateData">
      <app-update-data></app-update-data>
    </nb-card-body>
  </nb-card>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf=filterData>
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo pull-right"> Close </button>
  <button (click)="dataUpdate()" class="btn btn-success btn-semi-round btn-demo pull-right ml-1"
    [disabled]="!isChecked"> Update </button>
</mat-dialog-actions>
<mat-dialog-actions align="end" *ngIf=updateData>
  <button (click)="onBack()" class="btn btn-success btn-semi-round btn-demo pull-right ml-1"> Back </button>
  <!-- <button (click)="dataSave()" class="btn btn-success btn-semi-round btn-demo pull-right ml-1"> Save </button> -->
</mat-dialog-actions>
